// Phase 25 iter-8 — Buyer ↔ Seller chat about a marketplace sale.
//
// API surface (backend/src/routes/v1/conversations.ts):
//   GET    /conversations                      → list mine
//   POST   /conversations                      → create or fetch for sale_id
//   GET    /conversations/:id                  → conversation + messages
//   POST   /conversations/:id/messages         → send message
//   PATCH  /conversations/:id/read             → mark inbox messages as read
//   GET    /conversations/unread-count         → badge for the header
import { z } from 'zod';
export const MESSAGE_BODY_MAX = 2000;
export const ConversationParticipantSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    avatar_url: z.string().url().nullable().optional(),
});
export const ConversationSaleSummarySchema = z.object({
    id: z.string().uuid(),
    animal_name: z.string().nullable(),
    animal_crotal: z.string(),
    price_cents: z.number().int().nonnegative(),
});
export const ConversationListItemSchema = z.object({
    id: z.string().uuid(),
    sale: ConversationSaleSummarySchema,
    // O outro participante (sempre o que NON é o caller).
    counterparty: ConversationParticipantSchema,
    /** Última mensaxe (preview). null se a conversa acaba de crearse. */
    last_message: z
        .object({
        sender_id: z.string().uuid(),
        text: z.string(),
        created_at: z.string().datetime({ offset: true }),
    })
        .nullable(),
    unread_count: z.number().int().nonnegative(),
    last_message_at: z.string().datetime({ offset: true }),
});
export const ConversationListResponseSchema = z.object({
    conversations: z.array(ConversationListItemSchema),
});
export const ConversationMessageSchema = z.object({
    id: z.string().uuid(),
    sender_id: z.string().uuid(),
    text: z.string(),
    read_at: z.string().datetime({ offset: true }).nullable(),
    created_at: z.string().datetime({ offset: true }),
});
export const ConversationDetailSchema = z.object({
    id: z.string().uuid(),
    sale: ConversationSaleSummarySchema,
    buyer: ConversationParticipantSchema,
    seller: ConversationParticipantSchema,
    messages: z.array(ConversationMessageSchema),
});
export const CreateConversationRequestSchema = z
    .object({
    sale_id: z.string().uuid(),
})
    .strict();
export const CreateConversationResponseSchema = z.object({
    id: z.string().uuid(),
});
export const SendMessageRequestSchema = z
    .object({
    text: z.string().min(1).max(MESSAGE_BODY_MAX),
})
    .strict();
export const UnreadCountResponseSchema = z.object({
    unread: z.number().int().nonnegative(),
});
//# sourceMappingURL=conversation.js.map